export const filterNames = {
  "category": {
    "osen-2026": "ОСЕНЬ-2026",
    "baza": "Базовый гардероб с супервыгодой!",
    "domashnyaya-odezhda": "ДОМАШНЯЯ ОДЕЖДА",
    "bluzki-i-rubashki": "Блузки и рубашки",
    "dzhempery-i-svitery-vyazanye": "Джемперы и свитеры вязаные",
    "platya": "Платья",
    "hudi-svitshoty-tolstovki": "Худи, свитшоты, толстовки",
    "vodolazki-longslivy-kroenyy-trikotazh": "Водолазки, лонгсливы (кроеный трикотаж)",
    "futbolki": "Футболки",
    "topy": "Топы",
    "zhilety": "Жилеты",
    "zhakety-i-kardigany": "Жакеты и кардиганы",
    "bryuki-shveynye": "Брюки швейные",
    "bryuki-trikotazhnye": "Брюки трикотажные",
    "yubki": "Юбки",
    "dzhinsy": "Джинсы",
    "shorty": "Шорты",
    "vyazanyy-trikotazh": "Вязаный трикотаж",
    "futer": "Футер",
    "denim": "Деним",
    "eko-kozha": "Эко-кожа",
    "kostyumy-i-komplekty-trikotazhnye": "Костюмы и комплекты трикотажные",
    "kostyumy-i-komplekty-shveynye": "Костюмы и комплекты швейные",
    "sale": "РАСПРОДАЖА",
    "last-sizes": "-50% последние размеры!",
    "muzhskaya-kollektsiya": "МУЖСКАЯ КОЛЛЕКЦИЯ",
    "bryuki-trikotazhnye-muzhskie": "Брюки трикотажные мужские",
    "bryuki-shveynye-muzhskie": "Брюки швейные мужские",
    "dzhempery-i-svitery-vyazanye-muzhskie": "Джемперы и свитеры вязаные мужские",
    "dzhinsy-muzhskie": "Джинсы мужские",
    "kostyumy-muzhskie": "Костюмы мужские",
    "longslivy-muzhskie": "Лонгсливы мужские",
    "muzhskie-rubashki": "Мужские рубашки",
    "polo-muzhskie": "Поло мужские",
    "svitery-muzhskie": "Свитеры мужские",
    "tolstovki-hudi-muzhskie": "Толстовки, худи мужские",
    "futbolki-muzhskie": "Футболки мужские",
    "futer-muzhskoy": "Футер мужской",
    "shorty-muzhskie": "Шорты мужские",
    "sale-extra": "РАСПРОДАЖА %",
    "odezhda-dlya-devochek": "ОДЕЖДА ДЛЯ ДЕВОЧЕК",
    "odezhda-dlya-malchikov": "ОДЕЖДА ДЛЯ МАЛЬЧИКОВ",
    "bryuki-dlya-devochek": "Брюки для девочек",
    "vse-verha-detskie": "Все верха детские",
    "vse-nizy-detskie": "Все низы детские",
    "dzhinsy-dlya-devochek": "Джинсы для девочек",
    "dzhinsy-dlya-malchikov": "Джинсы для мальчиков",
    "kostyumy-dlya-devochek": "Костюмы для девочек",
    "kostyumy-dlya-malchikov": "Костюмы для мальчиков",
    "kroenyy-trikotazh-detskiy": "Кроеный трикотаж детский",
    "polo-dlya-malchikov": "Поло для мальчиков",
    "tolstovki-hudi-dlya-devochek": "Толстовки, худи для девочек",
    "tolstovki-hudi-dlya-malchikov": "Толстовки, худи для мальчиков",
    "trikotazhnye-bryuki-dlya-devochek": "Трикотажные брюки для девочек",
    "futbolki-dlya-malchikov": "Футболки для мальчиков",
    "futer-dlya-devochek": "Футер для девочек",
    "futer-dlya-malchikov": "Футер для мальчиков",
    "shorty-dlya-devochek": "Шорты для девочек",
    "shorty-dlya-malchikov": "Шорты для мальчиков"
  },
  "section": {
    "women": "Женщинам",
    "men": "Мужчинам",
    "kids": "Дети"
  },
  "collection": {
    "osen-2026": "ОСЕНЬ-2026",
    "muzhskaya-kollektsiya": "МУЖСКАЯ КОЛЛЕКЦИЯ"
  }
};
const paths = {category:'c',section:'s',collection:'k'};
export function decodeFilters(search, type, slug) {
  const result = new URLSearchParams(search);
  const key = Object.keys(paths).find(k => paths[k] === type);
  if (key && slug) result.set(key, filterNames[key][slug] || slug);
  for (const k of Object.keys(paths)) {
    const value = result.get(k);
    if (filterNames[k][value]) result.set(k, filterNames[k][value]);
  }
  return result;
}
export function filterUrl(input) {
  const params = new URLSearchParams(input);
  let path = '/vilatte';
  for (const key of Object.keys(paths)) {
    const value = params.get(key);
    const slug = Object.keys(filterNames[key]).find(s => filterNames[key][s] === value);
    if (!slug) continue;
    if (path === '/vilatte') { path += '/' + paths[key] + '/' + slug; params.delete(key); }
    else params.set(key, slug);
  }
  return path + (params.size ? '?' + params.toString() : '');
}
